import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme,
  Chip,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle, ExpandLess, ExpandMore } from "@mui/icons-material";
import { useState, useEffect, cloneElement } from "react";

// Recursive Menu Component
const MenuItemList = ({ items, showText, level = 0, toggleDrawerCallback }) => {
  // Load expanded state from localStorage if available
  const [expanded, setExpanded] = useState(() => {
    const saved = sessionStorage.getItem("menuExpanded");
    return saved ? JSON.parse(saved) : {};
  });

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleExpand = (key) => {
    setExpanded((prev) => {
      const newExpanded = {
        ...prev,
         [key]: !prev[key], // toggle only this one
      };
      sessionStorage.setItem("menuExpanded", JSON.stringify(newExpanded));
      return newExpanded;
    });
  };


  // Optional: listen for storage changes in case multiple tabs are open
  useEffect(() => {
    const handleStorage = () => {
      const saved = sessionStorage.getItem("menuExpanded");
      if (saved) setExpanded(JSON.parse(saved));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const LogoutCallback = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");
    localStorage.removeItem("employeeId");
    localStorage.removeItem("mobileApiUrl");
    localStorage.removeItem("outseta.auth--poisum.outseta.com.settings");
    localStorage.removeItem("outseta.emailList--poisum.outseta.com.settings");
    localStorage.removeItem("outseta.leadCapture--poisum.outseta.com.settings");
    localStorage.removeItem("outseta.nocode--poisum.outseta.com.settings");
    localStorage.removeItem("outseta.support--poisum.outseta.com.settings");
    localStorage.removeItem("isFirstTime");
    localStorage.removeItem("showOnboarding");
    sessionStorage.clear();

    navigate("/verifyEmail");
  };

  return (
    <List component="nav" disablePadding>
      {items.map((item, index) => {
        const hasChildren = !!item.children;
        const key = item.label; // or item.id if unique
        const isExpanded = expanded[key];
        const isLogout = item.action === "logout";

        const handleClick = () => {
          if (isLogout) {
            LogoutCallback();
          } else if (hasChildren) {
            toggleExpand(key);
          }
          if (!hasChildren && isMobile) {
            toggleDrawerCallback?.(); // close drawer
          }
        };

        return (
          <div key={`${item.label}-${index}`}>
            <ListItemButton
              component={item.to && !isLogout ? Link : "div"}
              to={item.to && !isLogout ? item.to : undefined}
              onClick={handleClick}
              sx={{
                // mx: 2,
                borderRadius: 2,
                pl: 2 + level * 2,
                minHeight: 20, // <-- reduce height here (default is 48)
                py: 0.3,  
                "&:hover": { backgroundColor: "secondary.main" },
                "&:active": { backgroundColor: "secondary.main" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 22 }}>
                {cloneElement(item.icon, { sx: { fontSize: theme.typography.subtitle.fontSize, } })}
              </ListItemIcon>
              {showText && <ListItemText primary={
                <Typography variant="body">
                {item.label}
              </Typography>} />}
              {hasChildren && (expanded[key] ? <ExpandLess sx={{ fontSize: 28 }} /> : <ExpandMore sx={{ fontSize: 28 }} />)}
            </ListItemButton>

            {hasChildren && (
              <Collapse in={!!expanded[key]} timeout="auto" unmountOnExit>
                <MenuItemList
                  items={item.children}
                  level={level + 1}
                  showText="true"
                />
              </Collapse>
            )}
          </div>
        );
      })}
    </List>
  );
};

export default MenuItemList;
